import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css'
// import AppTheme from '../shared-theme/AppTheme';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AppAppBar from './components/AppAppBar';
import Home from './components/Home';
import Footer from './components/Footer';
import AboutUsPage from './components/AboutUsPage';

export default function App() {
  return (
    <>
      <Router>
      <CssBaseline enableColorScheme />
      <AppAppBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<AboutUsPage />} />
        </Routes>
      </Router>
      <Footer />
    </>
  );
}